@if (place) {
  <ion-card class="ion-no-margin " [routerLink]="'/'+place.url">
    <ion-card-content class="ion-no-padding">
      <div class="flex justify-between">
        <div class=" max-w-[65vw]">
          @if (place.url) {
            <div class="line-clamp-3 font-bold text-xl">
              {{ place.title }}
            </div>
          } @else {
            <div class="line-clamp-3 font-bold text-xl">
              {{ place.title }}
            </div>
          }

          <div class="flex items-center">
            <div class="flex items-center flex-wrap max-w-full">
              @for (category of place.categories; track category.id) {
                <div class="flex items-center flex-nowrap mr-3">
                  <ng-icon name="heroBookmark" class="mr-1"/>
                  <span>{{ category.title }}</span>
                </div>
              }
            </div>
          </div>
        </div>

        @if (place.logo) {
          <div class="pl-3">
            <img [src]="place.logo" [alt]="place.title"
                 class="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-white border border-white"
            />
          </div>
        }
      </div>
    </ion-card-content>
  </ion-card>
}

